<ng-container [@fadeAnimation]>
    <div class="loading-image">
        <img class="image" src="/assets/images/loadingB.gif" alt="loading">
    </div>
    <div class="text"> {{ resource | translateIn:totem.language | async}}</div>
</ng-container>